export default __webpack_public_path__ + "static/media/windows.f897e130.svg";